import { useTranslation } from 'react-i18next';
import type { Namespace } from '../locales';

/**
 * Custom hook for translations with typed namespaces.
 *
 * @param ns - The namespace to use (common, validation, errors, grids, enums)
 * @returns Translation function and i18n utilities
 *
 * @example
 * // Default namespace (common)
 * const { t } = useT();
 * t('actions.save') // "Enregistrer"
 *
 * @example
 * // Specific namespace
 * const { t } = useT('validation');
 * t('required', { field: 'Nom' }) // "Nom est requis"
 *
 * @example
 * // Change language
 * const { changeLanguage } = useT();
 * changeLanguage('en');
 */
export const useT = (ns?: Namespace | Namespace[]) => {
  const { t, i18n } = useTranslation(ns);

  return {
    t,
    i18n,
    currentLang: i18n.language,
    changeLanguage: (lang: string) => i18n.changeLanguage(lang),
    isReady: i18n.isInitialized,
  };
};

export default useT;
